import { render, staticRenderFns } from "./tab-documents.vue?vue&type=template&id=211192a2"
import script from "./tab-documents.vue?vue&type=script&lang=js"
export * from "./tab-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports